<template>
    <div>
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">ประวัติการถอนเครดิต</h1>
                    <p class="text-white pb-3 px-3">ประวัติรายการถอนเครดิตออกจากบัญชีของคุณ</p>
                </div>
                <div class="col-12 col-md-12 col-lg-5 align-self-center px-3 text-right">
                    <button class="btn btn-xl btn-warning px-4" @click="withDrawCredit.show = true">
                        <Icon icon="mdi-cash-multiple" v-bind:style="{fontSize: '20px'}"/>
                        ถอนเครดิต
                    </button>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <div class="row justify-content-between">
                                <div class="col-lg-7">
                                    <b-form-group id="input-group-1" label="ค้นหาวันที่ทำรายการ (วันเริ่มต้น - วันสุดท้าย)" label-for="input-1" class="mb-0">
                                        <div class="row align-self-center">
                                            <div class="col-lg-5">
                                                <date-range-picker
                                                    class="w-100"
                                                    :opens="'center'"
                                                    @start-selection="logEvent('startSelection', $event)"
                                                    @finish-selection="logEvent('finishSelection', $event)"
                                                    :min-date="minDate"
                                                    :max-date="maxDate"
                                                    :singleDatePicker="false"
                                                    :appendToBody="true"
                                                    :ranges="false"
                                                    :closeOnEsc="false"
                                                    :autoApply="true"
                                                    :locale-data="{ format: 'dd-mm-yyyy' }"
                                                    v-model="filters">
                                                </date-range-picker>
                                            </div>
                                            <div class="col-lg-5">
                                                <b-form-input v-model="filter" type="text" placeholder="ค้นหาข้อมูลในตาราง"></b-form-input>
                                            </div>
                                            <div class="col-lg-2">
                                                <button class="btn btn-info btn-sm-res" @click="reportWithDrawCredit()">
                                                    <i class="fa fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </b-form-group>
                                    <hr class="d-block d-md-none d-lg-none mb-0" />
                                </div>
                                <div class="col-lg-3">
                                </div>
                                <div class="col-lg-2">
                                    <b-form-group label="Export File" class="mb-0 pb-2">
                                        <div class="btn-group btn-sm-res btn-export" role="group" aria-label="Basic example">
                                            <ExportExcel
                                                :columns="columnsExcel"
                                                :getData="getDataBranceExportExcel"
                                                name="ประวัติการถอนเครดิต "
                                            >
                                            </ExportExcel>
                                            <b-button variant="info btn-sm-res" @click="$htmlToPaper('tablePrint')">print</b-button>
                                        </div>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                        <div id="tablePrint">
                            <b-table
                                show-empty
                                responsive
                                empty-text="ไม่มีรายละเอียดการถอนเครดิต"
                                empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                                :items="dataWithDraw"
                                :fields="fields"
                                :filter="filter"
                                :busy="busy"
                                class="scroll-bar-pop"
                                foot-clone
                            >
                                <div slot="table-busy" class="text-center">
                                    <BlockUI>
                                        <div class="loader"></div>
                                    </BlockUI>
                                </div>
                                <template slot="index" slot-scope="data">{{ data.index+1 }}</template>
                                <template slot="created_at" slot-scope="row">{{ row.item.created_at | dateFormat }}</template>
                                <template slot="credit" slot-scope="row">
                                    {{ row.item.credit | numFormat('0,0.00') }}
                                </template>

                                <template slot="FOOT_index">รวม</template>
                                <template slot="FOOT_created_at">&nbsp;</template>
                                <template slot="FOOT_credit">{{footerTotal.credit | numFormat('0,0.00')}}</template>
                                <template slot="FOOT_remark">&nbsp;</template>
                            </b-table>
                            <div class="mt-3">
                                <b-pagination
                                    :total-rows="pagination.totalItem"
                                    :current-page="pagination.currentPage"
                                    :per-page="pagination.perPage"
                                    :value="pagination.currentPage"
                                    @input="changePage"
                                    align="right"
                                >
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ModalWithDrawCredit :withDrawCredit="withDrawCredit" />
    </div>
</template>
<script>
import moment from "moment";
import ExportExcel from '@/components/custom/exportExcel/ExportExcel'
import ModalWithDrawCredit from '@/components/Modals/ModalWithDrawCredit'
import { dateLimitRanges } from "@/plugins/datePicker.js"

export default {
    name: "withdrawcredit",
    components:{
        ExportExcel,
        ModalWithDrawCredit
    },
    data() {
        return {
            busy: false,
            minDate: null,
            maxDate: moment().format("YYYY-MM-DD"),
            filters: {
                excelDate: "",
                startDate: moment().format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD"),
            },
            withDrawCredit:{
                show: false
            },
            dataWithDraw: [],
            pagination:{
                totalPage: 1,
                totalItem: 1,
                currentPage: 1,
                perPage: 1
            },
            filter: null
        }
    },
    filters: {
        dateFormat(date) {
            return moment(date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm:ss");
        },
    },
    mounted() {
        this.reportWithDrawCredit();
    },
    methods: {
        logEvent( event , date ){
            const { minDate , maxDate } =  dateLimitRanges(event, date);
            this.minDate = minDate
            this.maxDate = maxDate
        },
        changePage(i){
            if (this.pagination.currentPage == i) return
            this.pagination.currentPage = i
            this.reportWithDrawCredit()
        },
        reportWithDrawCredit(){
            this.busy = true
            let dateStart = moment(this.filters.startDate).startOf('day').format("YYYY-MM-DD HH:mm:ss")
            let dateEnd = moment(this.filters.endDate).endOf('day').format("YYYY-MM-DD HH:mm:ss")
            this.$http
                .get(

                    this.$API_URL + "/wallet/agent/transaction/info",{
                        headers: {
                            Token: localStorage.getItem("access_token")
                        },
                        params: {
                            date_start: dateStart,
                            date_end: dateEnd,
                            subject: 'withdraw',
                            myWallet: true,
                            page: this.pagination.currentPage
                        }
                    }
                )
                .then(res => {
                    let data = res.data.data;
                    this.dataWithDraw = data.data;
                    this.pagination.totalPage = data.total_page
                    this.pagination.totalItem = data.total_item
                    this.pagination.currentPage = data.page
                    this.pagination.perPage = data.per_page
                    this.busy = false
                })
                .catch(error => {

                });
        },
        async getDataBranceExportExcel() {
            return new Promise( resolve => {
                let ExcelTask = []
                let page = 1;
                for( let i = 0 ; i < this.pagination.totalPage; i++ ){
                    ExcelTask.push( this.$http
                        .get(
                            this.$API_URL + "/wallet/agent/transaction/info",{
                                headers: {
                                    Token: localStorage.getItem("access_token")
                                },
                                params: {
                                    date_start: moment(this.filters.startDate).startOf('day').format("YYYY-MM-DD HH:mm:ss"),
                                    date_end: moment(this.filters.endDate).endOf('day').format("YYYY-MM-DD HH:mm:ss"),
                                    subject: 'withdraw',
                                    myWallet: true,
                                    page: page++
                                }
                            }
                        )
                    )
                }
                Promise.all(ExcelTask).then( (resData) => {
                    let dataExcel = [];
                    resData.forEach( data => {
                        dataExcel.push(...data.data.data.data)
                    })
                    resolve(dataExcel)
                })
            })
        },
    },
    computed: {
        fields(){
            let fields = [
                { key: "index", field: "index", label: "ลำดับ", sortable: true },
                { key: "created_at", field: "created_at", label: "วันเวลาที่ทำรายการ", sortable: true , class:"text-center" },
                { key: "credit", field: "credit", label: "จำนวนเครดิตที่ถอน", sortable: true , class:"text-center" },
                { key: "remark", field: "remark", label: "รายละเอียดการถอน", sortable: true },
            ]
            return fields
        },
        columnsExcel(){
            let columns =  [
                { field: "created_at", label: "วันเวลาที่ทำรายการ"  },
                {
                    field: "credit",
                    label: "จำนวนเครดิตที่ถอน",
                },
                { field: "remark", label: "รายละเอียดการถอน" }
            ]
            return columns
        },
        footerTotal() {
            let total = {
                credit: 0,
            }
            this.dataWithDraw.forEach(item => {
                total.credit += +item.credit
            })
            return total;
        }
    }
};
</script>
